<template>
  <div class="section1-container">
    <div class="box-wrapper">
      <div class="row m-0">
        <div class="col-12 box-wrapper-col">
          <div class="title">{{ $t("message.product.title") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@scss/product/section1.scss";
</style>